import OfferWallAchievement from './OfferWallAchievement';

export default OfferWallAchievement;
